import { IconCheckCircleFilled } from '@iwoca/icons';

import hourGlassSvg from '../../../assets/hourGlass.svg';

export const ApplicationStep = ({
  stepText,
  isComplete,
  showLine = true,
}: {
  stepText: string;
  isComplete: boolean;
  showLine?: boolean;
}) => {
  return (
    <>
      <div
        className={`${showLine && `w-[4px] justify-self-center ${isComplete ? 'bg-primary-20' : 'bg-structure-80'} mb-m mt-[-12px]`}`}
      />
      <div
        className={`flex items-center gap-s pt-l ${!isComplete && 'font-reg text-structure-60'}`}
      >
        {isComplete ? (
          <IconCheckCircleFilled width={24} height={24} />
        ) : (
          <img src={hourGlassSvg} alt="Hourglass" />
        )}
        {stepText}
      </div>
    </>
  );
};
